module.exports = __webpack_public_path__ + "static/media/Group 29123.8e7d4e1c.svg";